module.exports = __webpack_public_path__ + "static/img/PK5.534f436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK5.jpg
// module id = jHXU
// module chunks = 0